import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { UserActionFeatureSystemsComponent } from '../userAction-featureSystem/userAction-featureSystem.component';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { ValidFeatureService } from '../../../../Services/validFeature.service';
import { ValidFeatureSystem } from '../../../../Model/ValidFeatureSystem';
import { TranslateService } from '@ngx-translate/core';
import { FeatureSystem } from '../../../../Model/Catalog/FeatureModels/FeatureSystem';
import { ViewService } from '../../../../Services/view.service';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';
import { UserActionBaseComponent } from '../userAction-base.component';

@Component({
  selector: 'userAction-harmonizeFeatures',
  templateUrl: 'userAction-harmonizeFeatures.component.html',
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionHarmonizeFeaturesComponent) }
  ]
})
export class UserActionHarmonizeFeaturesComponent extends UserActionFeatureSystemsComponent {
  selectedFeatureSystem: ValidFeatureSystem;
  featuresLoading = false;
  featuresWithOrder: any[] = [];
  filteredFeatureSystems: ValidFeatureSystem[];

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    validFeatureService: ValidFeatureService,
    public systemService:SystemService
  ) {
    super(loginService,macroService, catalogService, validFeatureService);
  }

  async ngOnInit() {
    await super.ngOnInit();
    this.setFilterFeatureSystems(this.featureSystems);
  }

  setFilterFeatureSystems(featureSystems: ValidFeatureSystem[]) {
    this.filteredFeatureSystems = featureSystems.filter((x) => !ViewService.isSingleValue(x.name));
  }

  async onFeaturesystemChanged(e) {
    if (this.selectedFeatureSystem) {
      this.featuresLoading = true;
      let features = await this.loadFeatures(this.selectedFeatureSystem);
      this.featuresWithOrder = features.sort((a, b) => a.name.localeCompare(b.name));
      this.setOrders();
      this.featuresLoading = false;
    }
  }

  setOrders() {
    for (var i = 1; i <= this.featuresWithOrder.length; i++) {
      this.featuresWithOrder[i - 1].order = i;
    }
  }

  public async canStartMacro() : Promise<boolean>{
    if (!this.selectedFeatureSystem) {
      this.systemService.notifyInfo(this.translate.instant('FeatureSystem auswählen'));
      return false;
    }

    return true;
  }

  createParameterStringAsJsonString() {
    return JSON.stringify(this.featuresWithOrder);
  }

  public parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.featuresWithOrder = parsed.featuresWithOrder;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
